import { HEX_292D38 } from '@tanium/colors';

export const OverlayFill = () => HEX_292D38;
